export const EDITOR_DESELECT_ALL = 'EDITOR_DESELECT_ALL';
export const EDITOR_SELECT_PIN = 'EDITOR_SELECT_PIN';
export const EDITOR_DESELECT_PIN = 'EDITOR_DESELECT_PIN';
export const EDITOR_SELECT_ENTITY = 'EDITOR_SELECT_ENTITY';
export const EDITOR_DESELECT_ENTITY = 'EDITOR_DESELECT_ENTITY';
export const EDITOR_SET_SELECION = 'EDITOR_SET_SELECION';
export const EDITOR_ADD_ENTITY_TO_SELECTION = 'EDITOR_ADD_ENTITY_TO_SELECTION';

export const EDITOR_SWITCH_PATCH = 'EDITOR_SWITCH_PATCH';
export const EDITOR_SWITCH_TAB = 'EDITOR_SWITCH_TAB';

export const EDITOR_OPEN_ATTACHMENT = 'EDITOR_OPEN_ATTACHMENT';
export const EDITOR_CLOSE_ATTACHMENT = 'EDITOR_CLOSE_ATTACHMENT';

export const PATCH_WORKAREA_RESIZED = 'PATCH_WORKAREA_RESIZED';
export const SET_CURRENT_PATCH_OFFSET = 'SET_CURRENT_PATCH_OFFSET';

export const SET_FOCUSED_AREA = 'SET_FOCUSED_AREA';

export const PASTE_ENTITIES = 'PASTE_ENTITIES';

export const TAB_CLOSE = 'TAB_CLOSE';
export const TAB_SORT = 'TAB_SORT';

export const SHOW_HELPBOX = 'SHOW_HELPBOX';
export const HIDE_HELPBOX = 'HIDE_HELPBOX';
export const TOGGLE_HELP = 'TOGGLE_HELP';

export const SHOW_SUGGESTER = 'SHOW_SUGGESTER';
export const HIDE_SUGGESTER = 'HIDE_SUGGESTER';
export const HIGHLIGHT_SUGGESTER_ITEM = 'HIGHLIGHT_SUGGESTER_ITEM';

export const SHOW_LIB_SUGGESTER = 'SHOW_LIB_SUGGESTER';
export const HIDE_LIB_SUGGESTER = 'HIDE_LIB_SUGGESTER';

export const START_DRAGGING_PATCH = 'START_DRAGGING_PATCH';

export const INSTALL_LIBRARIES_BEGIN = 'INSTALL_LIBRARIES_BEGIN';
export const INSTALL_LIBRARIES_COMPLETE = 'INSTALL_LIBRARIES_COMPLETE';
export const INSTALL_LIBRARIES_FAILED = 'INSTALL_LIBRARIES_FAILED';

export const SET_SIDEBAR_LAYOUT = 'SET_SIDEBAR_LAYOUT';
export const RESIZE_PANELS = 'RESIZE_PANELS';
export const MINIMIZE_PANEL = 'MINIMIZE_PANEL';
export const MAXIMIZE_PANEL = 'MAXIMIZE_PANEL';
export const MOVE_PANEL = 'MOVE_PANEL';
export const TOGGLE_PANEL_AUTOHIDE = 'TOGGLE_PANEL_AUTOHIDE';

export const FOCUS_BOUND_VALUE = 'FOCUS_BOUND_VALUE';
export const FOCUS_LABEL = 'FOCUS_LABEL';

export const TABTEST_RUN_REQUESTED = 'TABTEST_RUN_REQUESTED';
export const TABTEST_GENERATED_CPP = 'TABTEST_GENERATED_CPP';
export const TABTEST_COMPILED = 'TABTEST_COMPILED';
export const TABTEST_LAUNCHED = 'TABTEST_LAUNCHED';
export const TABTEST_RUN_FINISHED = 'TABTEST_RUN_FINISHED';
export const TABTEST_ABORT = 'TABTEST_ABORT';
export const TABTEST_ERROR = 'TABTEST_ERROR';

export const SIMULATION_RUN_REQUESTED = 'SIMULATION_RUN_REQUESTED';
export const SIMULATION_GENERATED_CPP = 'SIMULATION_GENERATED_CPP';
export const SIMULATION_COMPILED = 'SIMULATION_COMPILED';
export const SIMULATION_LAUNCHED = 'SIMULATION_LAUNCHED';
export const SIMULATION_ABORT = 'SIMULATION_ABORT';
export const SIMULATION_ERROR = 'SIMULATION_ERROR';

export const TWEAK_PULSE_SENT = 'TWEAK_PULSE_SENT';
export const NODE_PROPERTY_UPDATING = 'NODE_PROPERTY_UPDATING';

export const SHOW_COLORPICKER_WIDGET = 'SHOW_COLORPICKER_WIDGET';
export const HIDE_COLORPICKER_WIDGET = 'HIDE_COLORPICKER_WIDGET';

export const OPEN_TABLE_LOG_TAB = 'OPEN_TABLE_LOG_TAB';
export const CHANGE_TABLE_LOG_SHEET = 'CHANGE_TABLE_LOG_SHEET';



// WEBPACK FOOTER //
// ../../src/editor/actionTypes.js